import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { createIcon, IconButton, label, useController, useLoseFocus } from "../../core/index.js";
import { useSlideshow } from "./SlideshowContext.js";
var PlayIcon = createIcon("Play", React.createElement("path", {
  d: "M8 5v14l11-7z"
}));
var PauseIcon = createIcon("Pause", React.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}));
export function SlideshowButton() {
  var _useSlideshow = useSlideshow(),
      playing = _useSlideshow.playing,
      disabled = _useSlideshow.disabled,
      togglePlaying = _useSlideshow.togglePlaying;

  var _useController = useController(),
      getLightboxProps = _useController.getLightboxProps;

  var _getLightboxProps = getLightboxProps(),
      render = _getLightboxProps.render,
      labels = _getLightboxProps.labels;

  var focusListeners = useLoseFocus(disabled);
  return render.buttonSlideshow ? React.createElement(React.Fragment, null, render.buttonSlideshow({
    playing: playing,
    togglePlaying: togglePlaying,
    disabled: disabled
  })) : React.createElement(IconButton, _objectSpread({
    label: playing ? label(labels, "Pause") : label(labels, "Play"),
    icon: playing ? PauseIcon : PlayIcon,
    renderIcon: playing ? render.iconSlideshowPause : render.iconSlideshowPlay,
    onClick: togglePlaying,
    disabled: disabled
  }, focusListeners));
}